import TYPES from './types';
import { get } from 'utils/api';

export const getRoutePoints = params => dispatch => {
  const { id } = params;

  dispatch({ type: TYPES.GET_ROUTE_POINTS.START });
  return get(`/routes/${id}`)
    .then(response => {
      dispatch({ type: TYPES.GET_ROUTE_POINTS.SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.GET_ROUTE_POINTS.ERROR, payload: error });
      throw error;
    });
};
